import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { SignIn } from "../pages/SignIn";
import { Layout } from "../pages/Layout";
import { Users } from "../pages/Users";
import { useStore } from "../store";
import { Dashboard } from "../pages/Dashboard";
import { Ingressos } from "../pages/Ingressos";
import { Motorista } from "../pages/Motorista";
import { Eventos } from "../pages/Eventos";
import { EventSubview } from "../pages/Eventos/EventSubview";
import Cadastro from "../pages/Cadastro";
import CadastroEvento from "../pages/CadastroEvento";
import ScannQRCode from "../pages/ScannQRCode";
import { Profile } from "../pages/Profile";
import CheckinPublico from "../pages/CheckinPublico";
import { ForgotPassword } from "../pages/ForgotPassword";

function AuthLayout({ children }: { children: JSX.Element }) {
  return (
    <RequireAuthWrapper>
      <RequireSuperUserWrapper>
        <Layout>{children}</Layout>
      </RequireSuperUserWrapper>
    </RequireAuthWrapper>
  );
}

function RequireAuthWrapper({ children }: { children: JSX.Element }) {
  const user = useStore((store) => store.user);
  const location = useLocation();

  if (!user.id) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

function RequireSuperUserWrapper({ children }: { children: JSX.Element }) {
  const user = useStore((store) => store.user);
  const location = useLocation();

  const permissions: Record<string, string> = {
    ADMIN: "ADMIN",
    SUPERADMIN: "SUPERADMIN",
    USERENTERPRISE: "USERENTERPRISE",
    USER: "USER",
  };

  if (user.user_type !== permissions[user.user_type]) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SignIn />} />

        <Route path="/cadastro" element={<Cadastro />} />
        <Route
          path="/cadastro/:eventId/:userId"
          element={<CadastroEvento />}
        />
        <Route path="/esqueci-senha" element={<ForgotPassword />} />
        <Route
          path="/inicio"
          element={
            <AuthLayout>
              <Dashboard />
            </AuthLayout>
          }
        />
        <Route
          path="/eventos"
          element={
            <AuthLayout>
              <Eventos />
            </AuthLayout>
          }
        />
        <Route
          path="/eventos/:eventId"
          element={
            <AuthLayout>
              <EventSubview />
            </AuthLayout>
          }
        />
        <Route
          path="/eventos/:eventId/editar"
          element={
            <AuthLayout>
              <EventSubview />
            </AuthLayout>
          }
        />
        <Route
          path="/eventos/:eventId/credenciamento"
          element={
            <AuthLayout>
              <EventSubview />
            </AuthLayout>
          }
        />
        <Route
          path="/eventos/:eventId/certificados"
          element={
            <AuthLayout>
              <EventSubview />
            </AuthLayout>
          }
        />
        <Route
          path="/eventos/:eventId/presenca"
          element={
            <AuthLayout>
              <EventSubview />
            </AuthLayout>
          }
        />
        <Route
          path="/ingressos"
          element={
            <AuthLayout>
              <Ingressos />
            </AuthLayout>
          }
        />
        <Route
          path="/inscricoes"
          element={
            <AuthLayout>
              <Motorista />
            </AuthLayout>
          }
        />
        <Route
          path="/galeria"
          element={
            <RequireAuthWrapper>
              <Layout>
                <Users />
              </Layout>
            </RequireAuthWrapper>
          }
        />

        <Route
          path="/perfil"
          element={
            <RequireAuthWrapper>
              <Layout>
                <Profile />
              </Layout>
            </RequireAuthWrapper>
          }
        />

        <Route
          path="/scanner/:participant_id/:event_id"
          element={<ScannQRCode />}
        />
        <Route path="/checkin-publico" element={<CheckinPublico />} />
      </Routes>
    </BrowserRouter>
  );
}
